import axios from "axios";
import { API_GET_PRODUCTS_DATA, API_GET_PRODUCT_CONFIGS_BY_PRODUCTS_DATA, API_GET_PRODUCT_CONFIGS_DATA, API_INSERT_PRODUCT_CONFIG_DATA, API_INSERT_PRODUCT_DATA, API_TOGGLE_PRODUCT_CONFIG_DATA, API_TOGGLE_PRODUCT_DATA, API_TOGGLE_PRODUCT_FEATURE_DATA, API_UPDATE_PRODUCT_CONFIG_DATA, API_UPDATE_PRODUCT_DATA, API_GET_PRODUCT_IMAGE_DATA, API_INSERT_PRODUCT_IMAGE_DATA, API_DELETE_PRODUCT_IMAGE_DATA } from ".";

export const getProductsList = async (func, config) => {
    return axios.get(API_GET_PRODUCTS_DATA, config).then(res => func(res.data.data));
};

export const insertProductData = async (data, config) => {
    return axios.post(API_INSERT_PRODUCT_DATA, data, config).then((res) => res.data);
};

export const updateProductData = async (data, config) => {
    return axios.put(API_UPDATE_PRODUCT_DATA, data, config).then((res) => res.data);
};
export const addProductImage = async (data, config) => {
    return axios.post(API_INSERT_PRODUCT_IMAGE_DATA, data, config).then((res) => res.data);
};

export const getProductImages = async (func, config, id) => {
    return axios.get(API_GET_PRODUCT_IMAGE_DATA+`?product_id=${id}`, config).then(res => func(res.data.data));
}

export const deleteProductImage = async (data, config, id) => {
    return axios.put(API_DELETE_PRODUCT_IMAGE_DATA, data, config).then(res => res.data);
}

export const toggleProductData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_PRODUCT_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};

export const toggleProductFeatureData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_PRODUCT_FEATURE_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};



export const getProductConfigsList = async (func, config) => {
    return axios.get(API_GET_PRODUCT_CONFIGS_DATA, config).then(res => func(res.data.data));
};

export const getProductConfigsByProductsList = async (func, config, id) => {
    return axios.get(`${API_GET_PRODUCT_CONFIGS_BY_PRODUCTS_DATA}?product_id=${id}`, config).then(res => func(res.data.data));
};

export const insertProductConfigData = async (data, config) => {
    return axios.post(API_INSERT_PRODUCT_CONFIG_DATA, data, config).then((res) => res.data);
};

export const updateProductConfigData = async (data, config) => {
    return axios.put(API_UPDATE_PRODUCT_CONFIG_DATA, data, config).then((res) => res.data);
};

export const toggleProductConfigData = async (data, config) => {
    return axios.put(API_TOGGLE_PRODUCT_CONFIG_DATA, data, config).then((res) => res.data);
};